import angular from 'angular';
import './announcement.service.js';
import _ from "lodash";

class AnnouncementDetailsCtrl {

    /*@ngInject*/
    constructor($state, logger, AuthSvc, $uibModal, CommunitySvc, $scope, PrincipalSvc, AnnouncementSvc,$window) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
        this.CommunitySvc = CommunitySvc;
        this.$scope = $scope;
        this.PrincipalSvc = PrincipalSvc;
        this.AnnouncementSvc = AnnouncementSvc;
        this.MAX_LENGTH_MESSAGE = 5000;
        this.$window = $window;
    }

    $onInit() {
        this.announcementId = this.$state.params.id;
        this.isForDuplication = this.$state.params.forDuplication;
        this.edit = false;
        this.isPublished = false;
        this.isReadyForDeletion = true
        this.announcement = {};
        this.announcement.isForSeller = true;
        this.announcement.isForBuyer = true;
        this.announcement.isForSellerInv = true;
        this.announcement.isForBuyerInv = true;
        this.announcement.countries = null;
        this.announcement.principals = null;
        this.announcement.announcementContents = [{
            language: null,
            title: null,
            message: null,
            isDefaultLang: true,
            media: {
                file: null,
                cacheFile: null,
                link: null,
                title: null,
                type: "PHOTO",
            }
        }];
        this.todayDate = new Date();
        this.langs = this.AnnouncementSvc.getLangs();
        this.isCommunityTransmitter = false;
        this.announcement.category = null;
        this.allCategories = this.AnnouncementSvc.getCategories();

        if (this.announcementId) {
            this.edit = !this.isForDuplication;
            this.announcement.id = this.isForDuplication ? null : this.announcementId
            this.AnnouncementSvc.getAnnouncement(this.announcementId).then(
                (data) => {
                    this.isReadyForDeletion = true
                    this.announcement.isForSeller = data.isForSeller;
                    this.announcement.isForBuyer = data.isForBuyer;
                    this.announcement.isForSellerInv = data.isForSellerInv;
                    this.announcement.isForBuyerInv = data.isForBuyerInv;
                    this.announcement.countries = data.countries;
                    this.announcement.principals = data.principals;
                    this.announcement.communityId = data.communityId;
                    if(this.edit){
                        this.announcement.dateFrom = new Date(data.startDate);
                        this.announcement.dateFrom.setHours(0, 0, 0, 0);
                        this.announcement.timeFrom = data.startDate;
                        this.announcement.dateTo = new Date(data.endDate);
                        this.announcement.dateTo.setHours(0, 0, 0, 0);
                        this.announcement.timeTo = data.endDate;
                    }
                    this.announcement.communityId = data.communityId;
                    this.announcement.communitySelected = this.communities.find(com => com.id == this.announcement.communityId)
                    this.isCommunityTransmitter = this.announcement.communityId != null ? true : false;
                    this.announcement.category = data.category
                    this.announcement.announcementContents = data.announcementContents
                    // permet d'afficher le contenue de la langue par defaut dans le bon ordre
                    let content = this.announcement.announcementContents.find(content => content.isDefaultLang === true);
                    const index = this.announcement.announcementContents.indexOf(content);
                    if (index > 0) {
                        this.announcement.announcementContents.splice(index, 1);
                        this.announcement.announcementContents.unshift(content);
                    }
                    let dateNow = new Date();
                    let fromDate = new Date(data.startDate)
                    // permet de verifier si le communiqué a été publié
                    if (fromDate.getTime() < dateNow.getTime() && this.edit) {
                        this.isPublished = true;
                    }
                },
                () => {
                    this.$state.go('app.announcement.list');
                }
            )
        }
    }

    unSelectCommunity() {
        this.announcement.communitySelected = null;
    }

    selectCommunity() {
        if (this.isCommunityTransmitter && this.communities.length == 1) {
            this.announcement.communitySelected = this.communities[0]
        }
    }

    cancel() {
        this.$state.go('app.announcement.list');
    }
    duplicate() {
        this.$window.scrollTo(0, 0);
        this.$state.go('app.announcement.duplicate',{ id : this.announcementId, forDuplication: true });
    }

    save() {
        if (this.form.$valid && this.isValidLangs() && this.checkMessageValidity()) {
            var data = this.prepareDataToSave();

            if (this.checkPublicationDateValidity(data.startDate, data.endDate)) {
                if (this.edit) {
                    this.AnnouncementSvc.updateAnnouncement(this.announcement).then(
                        () => {
                            this.logger.success('success.update', data, null, {
                                entityName: 'Le communiqué',
                            });
                            this.cancel();
                        },
                        error => {
                            if (error.status === 406) {
                                this.logger.warn(
                                    'Le format de la photo importée ne correspond pas au format attendu'
                                );
                            } else this.logger.error('error.update', error);
                        }
                    );
                } else {
                    this.AnnouncementSvc.createAnnouncement(data).then(
                        () => {
                            this.logger.success('success.create', data, null, {
                                entityName: 'Le communiqué',
                            });
                            this.cancel();
                        },
                        error => {
                            if (error.status === 406) {
                                this.logger.warn(
                                    'Le format de la photo importée ne correspond pas au format attendu'
                                );
                            } else this.logger.error('error.create', error);
                        }
                    );
                }
            }
        }
    }

    checkPublicationDateValidity(startDate, endDate) {
        let dateNow = new Date();
        if (startDate >= endDate) {
            this.logger.error("Incohérence entre l'heure de début et l'heure de fin de publication");
            return false;
        } else if (startDate <= dateNow && !this.isPublished) {
            this.logger.error("Heure de publication invalide");
            return false;
        } else if ((startDate >= endDate || endDate <= dateNow) && !this.isPublished) {
            this.logger.error("Date de publication invalide");
            return false;
        }
        return true;
    }

    prepareDataToSave() {
        // récupérer la bonne periode de publication depuis le timepicker
        let startTime = new Date(this.announcement.timeFrom)
        let fullStartDate = new Date(this.announcement.dateFrom)
        fullStartDate.setHours(startTime.getHours())
        fullStartDate.setMinutes(startTime.getMinutes())

        let endTime = new Date(this.announcement.timeTo)
        let fullEndDate = new Date(this.announcement.dateTo)
        fullEndDate.setHours(endTime.getHours())
        fullEndDate.setMinutes(endTime.getMinutes())

        this.announcement.communityId = this.isCommunityTransmitter ? this.announcement.communitySelected.id : null
        this.announcement.startDate = fullStartDate
        this.announcement.endDate = fullEndDate
        return this.announcement;
    }

    addLang() {
        this.announcement.announcementContents.push({
            language: null,
            message: null,
            isDefaultLang: false,
            media: {
                file: null,
                cacheFile: null,
                link: null,
                title: null,
                type: "PHOTO",
            }
        })
    }

    submit() {
        if (this.isPublished) {
            this.$uibModal
                .open({
                    component: 'modalUpdateAnnouncement',
                    size: 'md',
                    resolve: {
                        announcement: () => {
                            return this.announcement;
                        }
                    },
                }).result.then(
                () => {
                    this.save();
                },
                () => {
                }
            );
        } else {
            this.save();
        }
    }

    /*  Methode qui permet de savoir si un utilisateur a saisie plusieur fois la meme langue
    *   return false si oui true sinon
    * */
    isValidLangs() {
        var langs = []
        for (let index = 0; index < this.announcement.announcementContents.length; index++) {
            if (index == 0 || langs.indexOf(this.announcement.announcementContents[index].language) == -1) {
                langs[index] = this.announcement.announcementContents[index].language
            } else {
                this.logger.error('Une langue ne peut pas être sélectionnée plusieurs fois')
                return false;
            }
        }
        return true;
    }

    deleteLang(index) {
        this.$uibModal
            .open({
                component: 'modalDeleteAnnouncementTranslate',
                size: 'md',
                resolve: {
                    announcement: () => {
                        return this.announcement;
                    },
                    index: () => {
                        return index;
                    }
                },
            });
    }

    /*  Methode qui permet d'uploder un fichier de l'afficher
    *
    * */
    uploadFile($file, index) {
        //verifier que le fichier est bien present et conforme
        if ($file != null && this.verifyFile($file)) {
            // encodage du fichier en base 64
            const reader = new FileReader();
            reader.readAsDataURL($file);

            reader.onload = () => {
                this.announcement.announcementContents[index].media.file = reader.result;
                this.announcement.announcementContents[index].media.cacheFile = reader.result;
                document.getElementById("announcePicture" + index).src = this.announcement.announcementContents[index].media.file;

            }
        } else if (!this.announcement.announcementContents[index].media.file) {
            // on efface le contenue de fichier
            // si ce dernier n'est pas conforme uniquement si il n'a pas saisie au par avant un fichier conforme
            this.clearFile(index);
        }
    }

    /*  Methode permettant d'effacer le fichier uploder et de vider le cache du ficher
    *   et d'effacer le contenue du titre et de l'url du fichier
    * */
    fileRemove(index) {
        this.clearFile(index);
        this.announcement.announcementContents[index].media.title = null
        this.announcement.announcementContents[index].media.link = null

    }

    /* Methode permettant d'effacer le fichier uploder et de vider le cache du ficher
    *
    * */
    clearFile(index) {
        this.announcement.announcementContents[index].media.file = null
        this.announcement.announcementContents[index].media.cacheFile = null;
        document.getElementById("announcePicture" + index).src = ''
    }

    /*  Methode permettant de verifier si le fichier correspond au critère voulu
    *   return true si oui false sinon
    * */
    verifyFile(file) {
        let formatImageAccepted = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml'];
        var isValid = true;
        if (!_.includes(formatImageAccepted, file.type.toLowerCase()) || file.size / 1024 > 200) {
            this.logger.warn(
                'Le format de la photo importée ne correspond pas au format attendu'
            );
            isValid = false;
        }
        return isValid;
    }

    deleteAnnouncement() {
        this.$uibModal
            .open({
                component: 'modalDeleteAnnouncement',
                size: 'md',
                resolve: {
                    announcement: () => {
                        return this.announcement;
                    }
                },
            })
            .result.then(
            () => {
                this.goBackToList();
            },
            () => {
            }
        );
    }

    goBackToList() {
        this.$state.go('app.announcement.list');
    }

    /**
     *  permet de désactiver/activer le bouton de prévisualisation des communiqués
     * @param content contenu du bloc communiqué
     * @returns true si le bouton doit être grisé, false sinon
     */
    disableBtnPreview(content) {
        return (!content.message || content.message && content.message.trim().length === 0) || !content.title || !content.language ||
            !this.form.communitySelected.$valid || !this.form.categorySelected.$valid
            || !this.form.dateFrom.$valid || !this.form.timeFrom.$valid || !this.form.dateTo.$valid || !this.form.timeTo.$valid || this.isProfilNotSelected();
    }

    isProfilNotSelected() {
        return !this.announcement.isForSeller && !this.announcement.isForBuyer && !this.announcement.isForSellerInv && !this.announcement.isForBuyerInv;
    }

    /* Methode permettant de valider l'input text angular a fin de ne pas accepter les chaines de carac vide
     * et de ne pas accepter un message de plus de 5000 caractères
     * return true si oui false sinon
     * */
    checkMessageValidity() {
        return !this.announcement.announcementContents.some(c => c.message.trim().length === 0 || c.message.trim().length > this.MAX_LENGTH_MESSAGE);
    }

    previewAnnouncement(content) {
        this.$uibModal.open({
            component: 'modalPreviewAnnouncement',
            resolve: {
                content: () => content,
                announcement: () => this.announcement,
            },
            windowClass: 'app-modal-announcement',
        });
    }

}


angular.module('app.announcement').component('announcementDetails', {
    templateUrl: require('./announcement-details.html'),
    controller: AnnouncementDetailsCtrl,
    bindings: {
        communities: '<',
        announcement: '<',
    }
});
